import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const TermsAndConditionsLayout = () => {
    const [agreed, setAgreed] = useState(false);
    const navigate = useNavigate();

    const handleCheckboxChange = (e) => {
        setAgreed(e.target.checked);
    };

    const handleContinue = () => {
        if (agreed) {
            // alert("Agreement accepted. Proceeding..."); // if have API setup
            localStorage.setItem("agreedToTerms", "true"); // temp flag
            navigate("/homepage"); // redirect to homepage
        }
    };

    const handleCancel = () => {
        navigate("/"); // redirect to login page
    };

    return (
        <div className="bg-white shadow-md rounded-lg p-6 max-w-3xl mx-auto mt-10">
            {/* Main Heading */}
            <h3 className="text-center text-xl font-bold mb-4 text-black underline">
                Terms and Conditions
            </h3>

            {/* Content Section */}
            <div className="space-y-4">
                <h1 className="text-lg font-bold text-center text-black">
                    User Agreement of <span className="text-pink-600">OpenApiPass</span>
                </h1>

                {/* Left-aligned content block */}
                <div className="text-left text-sm text-gray-800 space-y-4">
                    <p>This document governs:</p>
                    <ul className="list-disc list-inside">
                        <li>Your use of the OpenApiPass website and related services</li>
                        <li>Any other agreement or legal relationship you form with us through the platform</li>
                    </ul>

                    <p>By accessing or using OpenApiPass, you agree to the following terms and conditions.</p>

                    <h2 className="text-center text-lg font-semibold mt-6">
                        What You Should Know at a Glance
                    </h2>
                    <p>
                        Some provisions may only apply to certain categories of users (e.g., developers).
                    </p>

                    <h2 className="text-center text-lg font-semibold mt-6">TERMS OF USE</h2>
                    <p>
                        These terms apply to anyone using OpenApiPass, including developers accessing our API
                        documentation and sandbox environment.
                    </p>
                    <ul className="list-disc list-inside">
                        <li>You must be at least <span className="text-red-600">18</span> years old to register.</li>
                        <li>You must not be located in or affiliated with any entity under U.S. embargo or sanctions.</li>
                        <li>You must not reverse-engineer or misuse API keys or endpoints.</li>
                    </ul>

                    <h3 className="text-left font-bold mt-4">Account Registration</h3>
                    <p>You may need to register for full access (e.g., API keys, dashboard).</p>
                    <ul className="list-disc list-inside">
                        <li>No bots or automated registration.</li>
                        <li>One account per user unless approved.</li>
                        <li>Keep login credentials secure. You are responsible for account activity.</li>
                    </ul>

                    <h3 className="text-left font-bold mt-4">Termination & Suspension</h3>
                    <p>We may suspend/delete accounts for misuse, excessive requests, or violating terms. You won’t be entitled to compensation.</p>

                    <h3 className="text-left font-bold mt-4">Use of API & Platform Resources</h3>
                    <p>All code samples, docs, and keys are provided under a non-exclusive, non-transferable license for personal or organizational use. Commercial use without consent is prohibited.</p>

                    <h3 className="text-left font-bold mt-4">Third-Party Services</h3>
                    <p>Our site may link to third-party services. We’re not responsible for their content or terms.</p>

                    <h3 className="text-left font-bold mt-4">Acceptable Use</h3>
                    <p>You may not use OpenApiPass to:</p>
                    <ul className="list-disc list-inside">
                        <li>Violate laws or infringe intellectual property</li>
                        <li>Access systems without authorization</li>
                        <li>Spam or degrade service performance</li>
                    </ul>

                    <h2 className="text-center text-lg font-semibold mt-6">PRICING AND PAYMENTS</h2>
                    <p>Most OpenApiPass services are free. Paid tiers may be introduced later and will be subject to separate terms.</p>

                    <h2 className="text-center text-lg font-semibold mt-6">LIABILITY</h2>
                    <p>OpenApiPass is provided "as-is". We are not liable for damages unless required by law (e.g., gross negligence or intentional harm).</p>

                    <h2 className="text-center text-lg font-semibold mt-6">INTELLECTUAL PROPERTY</h2>
                    <p>All logos, branding, source content, and APIs belong to OpenApiPass or licensors. Do not copy or reuse them without permission.</p>

                    <h2 className="text-center text-lg font-semibold mt-6">CHANGES TO TERMS</h2>
                    <p>Terms may change. Your continued use means you accept updated terms. You’ll be notified where required.</p>

                    <h2 className="text-center text-lg font-semibold mt-6">GOVERNING LAW AND DISPUTE RESOLUTION</h2>
                    <p>These terms are governed by Singapore law. All disputes will be handled by the courts of Singapore unless otherwise stated.</p>

                    <h2 className="text-center text-lg font-semibold mt-6">CONTACT US</h2>
                    <p>For questions or support, please email: <code>community@codeforeword.org</code></p>
                </div>
            </div>
            <br></br>
            <p className="text-xs text-gray-500 mb-4">Last Updated: July 7, 2025</p>
            <div className="mb-6">
                <label className="inline-flex items-start space-x-2">
                    <input
                        type="checkbox"
                        checked={agreed}
                        onChange={handleCheckboxChange}
                        className="mt-1"
                    />
                    <span className="text-sm text-gray-700">
                        I have read and agree to the privacy policy, terms and conditions and guidelines.
                    </span>
                </label>
            </div>
            <div className="flex flex-col space-y-2">
                <button
                    onClick={handleContinue}
                    disabled={!agreed}
                    className={`w-full py-2 px-4 rounded-md text-white text-sm font-medium ${agreed ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
                        }`}
                >
                    Continue
                </button>
                <button
                    onClick={handleCancel}
                    className="w-full py-2 px-4 rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700"
                >
                    Cancel
                </button>
            </div>
        </div>
    );
};
export default TermsAndConditionsLayout;